import React, { useEffect, useState } from "react";
import "../styles/bookingtoast.css";

const BookingToast = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if toast was dismissed in this session
    const dismissed = sessionStorage.getItem("bookingToastDismissed");
    if (!dismissed) {
      const timer = setTimeout(() => {
        setShow(true);
      }, 20000);
      return () => clearTimeout(timer);
    }
  }, []);

  const dismissToast = () => {
    setShow(false);
    sessionStorage.setItem("bookingToastDismissed", "true");
  };

  const handleBookingClick = () => {
    setShow(false);
    // Optional: you can still set the dismissal flag if you don't want it reappearing
    sessionStorage.setItem("bookingToastDismissed", "true");
  };

  if (!show) return null;

  return (
    <div className="booking-toast">
      <div className="toast-content">
        <p className="toast-message">Foglalj időpontot még ma!</p>
        <a
          href="#contact"
          onClick={handleBookingClick}
          className="btn btn-warning text-dark fw-semibold rounded-pill px-3 py-2"
        >
          Időpontfoglalás
        </a>
      </div>
      <button className="toast-close" onClick={dismissToast}>
        ✕
      </button>
    </div>
  );
};

export default BookingToast;
